'use client';
import Link from 'next/link';
import Nav from '../../components/nav';
import { CldImage } from 'next-cloudinary';

export default function ThankYouPage() {
    return (
        <div>
            <Nav variant="light" />
            <div className="pt-40 pb-24 text-center w-full mx-auto max-w-container lg:pt-56 lg:pb-48">
                <div className="mx-6">
                    <p className="relative object-cover w-full mx-auto aspect-square max-w-[306px]">
                        <CldImage src="thank-you-page" alt="" fill className="rounded-full" />
                    </p>
                    <h1 className="mt-10 font-medium h2">Awesome! What&apos;s next?</h1>
                    <p className="max-w-2xl mx-auto mt-6 p-lg">
                        We’ve recieved your form submission and will be in touch soon. In the meantime, check out our
                        latest{' '}
                        <Link href="/case-studies" className="border-b-out">
                            Case Studies
                        </Link>{' '}
                        and{' '}
                        <Link href="/about/journal" className="border-b-out">
                            Journal Posts
                        </Link>
                        .
                    </p>
                </div>
            </div>
        </div>
    );
}
